export function recordVoiceTiming(event) {
  const name = String(event?.name ?? '')
  if (!name) return
  const detail = { ...event, observed_at_ms: Date.now() }
  if (typeof globalThis.performance?.mark === 'function') {
    try {
      globalThis.performance.mark(`dochat.voice.${name}`, { detail })
    } catch {
      globalThis.performance.mark(`dochat.voice.${name}`)
    }
  }
  if (typeof globalThis.window?.dispatchEvent === 'function' && typeof globalThis.CustomEvent === 'function') {
    globalThis.window.dispatchEvent(new globalThis.CustomEvent('dochat:voice-latency', { detail }))
  }
}
